import { NetworkstatsState } from './networkstats.state'
import { getters } from './networkstats.getters'
import { mutations } from './networkstats.mutations'
import { actions } from './networkstats.actions'
// import { UserNetworkStats } from '@/types/networkstats'
// import { KeyDict } from '@/types'
import { moduleActionContext } from '../..'

// initial state
const initialState: NetworkstatsState = new NetworkstatsState()

const networkStatsModule = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
} as const

export default networkStatsModule
export const networkStatsModuleActionContext = context => moduleActionContext(context, networkStatsModule)
